// This file was auto-generated by querybuilder/Apollo and should not be edited.

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: LandlordDetailsType
// ====================================================

export interface LandlordDetailsType {
  /**
   * Usually the first line of the address, e.g. "150 Court Street"
   */
  primaryLine: string;
  /**
   * The city of the address, e.g. "Brooklyn".
   */
  city: string;
  /**
   * The zip code of the address, e.g. "11201" or "94107-2282".
   */
  zipCode: string;
  /**
   * The landlord's name.
   */
  name: string;
  /**
   * The landlord's email address.
   */
  email: string;
  /**
   * A U.S. phone number without parentheses or hyphens, e.g. "5551234567".
   */
  phoneNumber: string;
  /**
   * Whether the name and address was looked up automatically, or manually entered by the user.
   */
  isLookedUp: boolean;
  /**
   * The full mailing address of the user, as a single string. Note that this may
   * actually be populated even if individual address fields are empty; this
   * represents legacy data created before we split up addresses into individual fields.
   */
  address: string;
  state: string;
}

export const BlankLandlordDetailsType: LandlordDetailsType = {
  "primaryLine": "",
  "city": "",
  "zipCode": "",
  "name": "",
  "email": "",
  "phoneNumber": "",
  "isLookedUp": false,
  "address": "",
  "state": ""
};

export const graphQL = `# This file was auto-generated by querybuilder, please do not edit it.
fragment LandlordDetailsType on LandlordDetailsType {
  primaryLine,
  city,
  zipCode,
  name,
  email,
  phoneNumber,
  isLookedUp,
  address,
  state
}`;